<template>
  <div>
    <TrustCenter ref="centerList"></TrustCenter>
  </div>
</template>

<script>

import TrustCenter from "./center/TrustCenter.vue";
export default {
  components: { TrustCenter },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    
  }
};
</script>

<style lang="less" scoped>

</style>
